var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-text-content"},[_c('h3',{class:{'gc-title': true, 'locked': _vm.blurLock, 'locked-title': _vm.blurLock}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{class:{locked: _vm.blurLock},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }